import { render, staticRenderFns } from "./OtpConfirmationPopup.vue?vue&type=template&id=b2f1ec32&scoped=true"
import script from "./OtpConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./OtpConfirmationPopup.vue?vue&type=script&lang=js"
import style0 from "./OtpConfirmationPopup.vue?vue&type=style&index=0&id=b2f1ec32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f1ec32",
  null
  
)

export default component.exports